import { Navigate, useLocation } from "react-router";

export default function Closed() {
  const { state } = useLocation();

  if (!state?.redirected) {
    return <Navigate to="/" />;
  }

  return (
    <div className="card mx-auto w-full max-w-lg px-4 py-8 text-center">
      {state?.data?.maintenance && (
        <>
          {state?.data?.title && (
            <h1 className="text-red mb-4 font-bold">{state?.data?.title}</h1>
          )}
          {state?.data?.description && (
            <h2 className="text-red mx-auto max-w-xs text-center font-bold">
              {state?.data?.description}
            </h2>
          )}

          {state?.data?.message && (
            <h2 className="text-red mx-auto max-w-xs text-center font-bold">
              {state?.data?.message}
            </h2>
          )}
        </>
      )}

      {!state?.data?.maintenance && (
        <>
          <h1 className="text-red mb-4 font-bold">Sorry</h1>
          <h2 className="text-red mx-auto max-w-xs text-center font-bold">
            This promotion has now finished.
          </h2>
        </>
      )}
    </div>
  );
}
